import { toast } from "sonner";
import { MessageSquare, Link2 } from "lucide-react";

const FB = "M13.5 21v-7.5h2.5l.4-3h-2.9V8.6c0-.9.3-1.5 1.5-1.5h1.6V4.4c-.3 0-1.2-.1-2.3-.1-2.3 0-3.9 1.4-3.9 4v2.2H7.9v3h2.5V21h3.1z";
const IG = "M12 7.4a4.6 4.6 0 1 0 0 9.2 4.6 4.6 0 0 0 0-9.2zm0 7.6a3 3 0 1 1 0-6 3 3 0 0 1 0 6zm4.8-8.9a1.1 1.1 0 1 0 0 2.2 1.1 1.1 0 0 0 0-2.2zM21 7.9c-.1-1.5-.4-2.8-1.5-3.9S17.1 2.6 15.6 2.5c-1.5-.1-6.1-.1-7.6 0-1.5.1-2.8.4-3.9 1.5S2.6 6.4 2.5 7.9c-.1 1.5-.1 6.1 0 7.6.1 1.5.4 2.8 1.5 3.9s2.4 1.4 3.9 1.5c1.5.1 6.1.1 7.6 0 1.5-.1 2.8-.4 3.9-1.5s1.4-2.4 1.5-3.9c.1-1.5.1-6.1 0-7.6z";
const Svg = ({ d }) => <svg viewBox="0 0 24 24" className="h-4 w-4" fill="currentColor" aria-hidden="true"><path d={d} /></svg>;
const btn = "flex h-11 items-center gap-2 border border-neutral-300 px-4 text-[11px] uppercase tracking-[0.2em] text-neutral-800 transition-colors hover:border-neutral-950 hover:bg-neutral-950 hover:text-white";

const copy = async (url, msg) => {
  try {
    await navigator.clipboard.writeText(url);
    toast.success(msg);
  } catch {
    toast.error("Couldn't copy the link. Please copy it from the address bar.");
  }
};

// One-tap sharing. Instagram has no web share link, so phones open the share sheet
// (which includes Instagram) and computers copy the link to paste into Instagram.
// `shareUrl` (weekly articles) points at a page with real share-card tags, so Facebook shows the cover image.
export const ShareButtons = ({ title, testid = "share", shareUrl }) => {
  const url = shareUrl || window.location.href;
  const text = `${title} — Lux Veritae Journal`;
  const instagram = async () => {
    if (navigator.share) {
      try { await navigator.share({ title: text, url }); } catch { /* closed by user */ }
      return;
    }
    copy(url, "Link copied. Paste it into your Instagram story or message.");
  };
  return (
    <div className="flex flex-wrap items-center justify-center gap-3" data-testid={testid}>
      <span className="w-full text-center text-[10px] uppercase tracking-[0.35em] text-neutral-500 sm:w-auto sm:pr-2">Share</span>
      <a href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`} target="_blank" rel="noreferrer" className={btn} data-testid={`${testid}-facebook`}><Svg d={FB} />Facebook</a>
      <button type="button" onClick={instagram} className={btn} data-testid={`${testid}-instagram`}><Svg d={IG} />Instagram</button>
      <a href={`sms:?&body=${encodeURIComponent(`${text} ${url}`)}`} className={btn} data-testid={`${testid}-text`}><MessageSquare size={15} strokeWidth={1.5} />Text</a>
      <button type="button" onClick={() => copy(url, "Link copied.")} className={btn} data-testid={`${testid}-copy`}><Link2 size={15} strokeWidth={1.5} />Copy</button>
    </div>
  );
};
